import { t } from '@lingui/core/macro';
import { validPhoneRegex } from 'shared/validators/phone.validator';
import * as yup from 'yup';

import { AuthRequestAuthCodePayload } from '../interfaces/auth-request-auth-code-payload';

/** Сообщения — функции: yup зовёт их в момент валидации, поэтому текст берётся на текущем языке. */
export const authRequestCodeValidator = (): yup.SchemaOf<AuthRequestAuthCodePayload> =>
  yup.object().shape({
    phone: yup
      .string()
      .required(() => t`Номер телефона обязателен`)
      .matches(validPhoneRegex, () => t`Введите корректный номер телефона`),
  });
